import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { User } from "../../utils/models/User";
import { LocalStorage } from "../../service/LocalStorage";
import { USER_KEY } from "../../utils/constants/localStorageKeys";

const user = LocalStorage.get<User>(USER_KEY);

interface UserState {
  user: User | null;
}

const initialState: UserState = {
  user: typeof user !== "string" ? user : null,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User>) => {
      state.user = action.payload;
      LocalStorage.set(USER_KEY, JSON.stringify(action.payload));
    },
  },
});

export const { setUser } = userSlice.actions;
export default userSlice.reducer;
